"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/** HOC to wrap children based on condition */
var ConditionalWrapper = function (_a) {
    var condition = _a.condition, wrapper = _a.wrapper, children = _a.children;
    return (React.createElement(React.Fragment, null, condition ? wrapper(children) : children));
};
exports.default = React.memo(ConditionalWrapper);
//# sourceMappingURL=index.js.map